import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useOfferCheckContext} from 'components/Accommodation/Rooms/OfferCheckContext'
import {getRoomDetailOverlayVisibility} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'

import {Offer} from '@daedalus/core/src/offer/types/offer'
import {SplitBooking} from '@daedalus/core/src/room/types/room'

import {useGetComposedOfferCheckAPIParamsBuilder} from './useGetComposedOfferCheckAPIParams'

type Props = {
  offer: {offer?: Offer; splitBooking?: SplitBooking}
}

const NAVIGATION_DELAY = 50

export const useDefferedOfferInteraction = ({offer}: Props) => {
  const isRoomsDetailsOverlayOpen = useSelector(getRoomDetailOverlayVisibility)
  const {buildOfferCheckParams} = useGetComposedOfferCheckAPIParamsBuilder()
  const {triggerOfferCheck} = useOfferCheckContext()
  const {offer: roomOffer, splitBooking} = offer
  const dispatch = useDispatch()
  const defferedOfferClick = useCallback(
    (landingUrl: string) => {
      const apiParams = buildOfferCheckParams(offer)

      if (isRoomsDetailsOverlayOpen) {
        dispatch(hideOverlay())
      }

      triggerOfferCheck({
        apiParams,
        offerId: roomOffer ? roomOffer.id : splitBooking?.bundleId,
        onSuccess: ({httpRequestId}: {httpRequestId: string}) => {
          setTimeout(() => {
            window.location.href = `${landingUrl}&apRequestId=${httpRequestId}`
          }, NAVIGATION_DELAY)
        }
      })
    },
    [buildOfferCheckParams, offer, isRoomsDetailsOverlayOpen, dispatch]
  )

  return {
    defferedOfferClick
  }
}
